export default __webpack_public_path__ + "static/824b59ad-ee2f-4078-9740-d119f90b29be-f038915b263e434b079b095291ef9e88.woff2";